import React,{Component} from "react";

import {Footer} from '../footer/Footer';
import {Header} from '../header/Header';
export class CharimanHistory extends Component{
    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
            <div className="container">
                <div className="text-center">
                    <h3>HISTORY OF CHAIRMAN</h3>
                </div>
                <ul>
                    <li>
                        <p><b>Mr. M. I. Memon </b></p>
                        <p>FROM: 1-Feb-1974 TO: 20-Jun-1984</p>
                    </li>
                    <li>
                    <p><b>Syed Ahsan Ali shah </b></p>
                        <p>FROM: 20-Jun-1984 TO: 16-Jul-1975</p>
                    </li>
                    <li>
                    <p><b>Mr. Rustam V. Divecha </b></p>
                        <p>FROM: 16-Jul-1975 TO: 29-Aug-1975</p>
                    </li>
                    <li>
                    <p><b>Prof A. M. Fareed </b></p>
                        <p>FROM: 29-Aug-1975 TO: 25-Sep-1976</p>
                    </li>
                    <li>
                    <p><b>Mr. Rustam V. Divecha </b></p>
                        <p>FROM: 25-Sep-1976 TO: 9-May-1977</p>
                    </li>
                    <li>
                    <p><b>Prof M. E. Abro </b></p>
                        <p>FROM: 9-May-1977 TO: 27-Apr-1978</p>
                    </li>
                    <li>
                    <p><b>Mr. Rustam V. Divecha </b></p>
                        <p>FROM: 27-Apr-1978 TO: 18-Apr-1979</p>
                    </li>
                    <li>
                    <p><b>Prof M. Ali Khan </b></p>
                        <p>FROM: 18-Apr-1979 TO: 10-Apr-1984</p>
                    </li>
                    <li>
                    <p><b>Mr. Mohammad Siyat </b></p>
                        <p>FROM: 10-Apr-1984 TO: 17-Nov-1984</p>
                    </li>
                    <li>
                    <p><b>Prof Nawab Alam farooqui </b></p>
                        <p>FROM: 14-Jul-1988 TO: 27-Aug-1988</p>
                    </li>
                    <li>
                    <p><b>Prof Aftab Ahmed Khan </b></p>
                        <p>FROM: 27-Aug-1988 TO: 12-Nov-1990</p>
                    </li>
                    
                    <li>
                    <p><b>Mr. M. I. Memon </b></p>
                        <p>FROM: 12-Nov-1990 TO: 12-Sep-1991</p>
                    </li>
                    <li>
                    <p><b>Prof Naeem Ullah Siddiqui </b></p>
                        <p>FROM: 12-Sep-1991 TO: 25-Nov-1991</p>
                    </li>
                    <li>
                    <p><b>Mr. M. S. Gopang </b></p>
                        <p>FROM: 10-Feb-1992 TO: 28-Jun-1992</p>
                    </li>
                    <li>
                    <p><b>Prof Naeem Ullah Siddiqui </b></p>
                        <p>FROM: 28-Jun-1992 TO: 2-Feb-1994</p>
                    </li>
                    <li>
                    <p><b>Dr. A. Wakeel Kureshi </b></p>
                        <p>FROM: 2-Feb-1994 TO: 12-Feb-1998</p>
                    </li>
                    <li>
                    <p><b>Prof. Dr. M. Faheem Uddin </b></p>
                        <p>FROM: 12-Feb-1998 TO: 28-Nov-1999</p>
                    </li>
                    <li>
                    <p><b>Prof Dr. m. Sharif Memon </b></p>
                        <p>FROM: 28-Nov-1999 TO: 16-Dec-2002</p>
                    </li>
                    <li>
                    <p><b>Prof S. Iftikhar H. Zaidi</b></p>
                        <p>FROM: 16-Dec-2002 TO: 16 June 2007</p>
                    </li>
                    <li>
                    <p><b>Mr. Anwar Ahmed Zai </b></p>
                        <p>FROM: 20th June 2007 TO: 19th June 2015</p>
                    </li>
                    <li>
                    <p><b>Mr. Akhtar Ghori </b></p>
                        <p>FROM: 20th June 2015 TO: 30th Sep 2016</p>
                    </li>
                    <li>
                    <p><b>Prof. Inam Ahmed </b></p>
                        <p>FROM: 1st Oct 2016 TO: To-Date</p>
                    </li>
                    <li>
                    <p><b>Mr. M. I. Memon </b></p>
                        <p>FROM: 1-Feb-1974 TO: 20-Jun-1984</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}